import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { chargeSelectionStyles } from "@/pages/sy/styles/ChargeSelectionStyles";
import { HeatGroup } from "../ChargeSelectionScreen";

export const TableScheduledHeats = ({
  visibleHeatGroups,
  selectedHeatIndex,
  handleHeatSelect,
}: {
  visibleHeatGroups: HeatGroup[];
  selectedHeatIndex: number | null;
  handleHeatSelect: (index: number) => void;
}) => {
  const theme = useTheme();
  const styles = chargeSelectionStyles(theme);

  return (
    <TableContainer sx={styles.heatTableContainer}>
      <Table stickyHeader size="medium">
        <TableHead>
          <TableRow sx={styles.heatTableHeader}>
            <TableCell align="center">Scheduled Heat</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {visibleHeatGroups.map((heatGroup, index) => (
            <TableRow
              key={`${heatGroup.scheduledHeatName}-${heatGroup.recipeName}`}
              sx={{
                ...(styles.heatTableRow as object),
                ...(selectedHeatIndex === index
                  ? (styles.heatSelectedRow as object)
                  : {}),
              }}
              onClick={() => handleHeatSelect(index)}
            >
              <TableCell align="center">
                {heatGroup.scheduledHeatName}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
